/* Imports */
import React from "react"
import { Table } from "fajny-react"
import { v4 as uuid } from "uuid"

import ComponentPage from "../../components/ComponentPage"
import CodeContainer from "../../components/CodeContainer"

import allMixins from "../../data/all-mixins"

const MixinsPage = () => {
    return (
        <ComponentPage>
            <Table tableStyle="bordered" vAlign="top">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Effect</th>
                        <th>Variables</th>
                        <th>Example</th>
                    </tr>
                </thead>

                <tbody>
                    {allMixins.map(mixin => (
                        <tr key={uuid()}>
                            <td>{mixin.name}</td>
                            <td>{mixin.effect}</td>
                            <td>{mixin.variables}</td>
                            <td style={{ padding: 0 }}>
                                <CodeContainer button={false}>{mixin.example}</CodeContainer>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </ComponentPage>
    )
}

export default MixinsPage
